import classNames from 'classnames'
import ButtonBase, { ButtonBaseProps } from './ButtonBase'
import styles from './button.module.scss'

export type ButtonVariant =
  | 'primary'
  | 'primary_outline'
  | 'secondary'
  | 'brand_orange'
  | 'white'
  | 'white_outline'
  | 'transparent'

export type ButtonProps = {
  variant?: ButtonVariant
  classes?: string
  selected?: boolean
} & ButtonBaseProps

function Button({
  variant = 'primary',
  classes = '',
  selected = false,
  ...props
}: ButtonProps) {
  const buttonClasses = classNames(styles[variant] || '', classes, {
    [styles.selected]: selected
  })
  return <ButtonBase {...props} classes={buttonClasses} />
}

export default Button
